import { Component, OnInit, Input, EventEmitter, Output, Inject, OnDestroy, AfterViewInit, forwardRef, ViewChild, AfterContentInit } from '@angular/core';
import { IDirectReport } from '../../lookups';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Select } from '../../shared/efaact-primeng.module';

@Component({
    selector: 'ef-user-selector-dropdown',
    templateUrl: './user-selector-dropdown.component.html',
    styleUrls: ['./user-selector-dropdown.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UserSelectorDropdownComponent),
            multi: true
        }
    ],
    standalone: false
})
export class UserSelectorDropdownComponent
  implements OnInit, AfterViewInit, AfterContentInit, ControlValueAccessor {
  @Input() Users: Array<IDirectReport>;
  @Input() public filter: boolean;
  @Input() public placeholder: string;
   @ViewChild('ddUser', { static: true }) ddUser: Select;
  private formControlChanged: Function;
  private formControlTouched: Function;
  constructor(
    @Inject(LoggingService) private log: LoggingService,

  ) { }

  ngOnInit() {
    this.log.verbose({type: 'UserSelectorDropdownComponent:ngOnInit', Users: this.Users});
  }
  ngAfterContentInit (): void {
    this.ddUser.registerOnChange(this.formControlChanged);
    this.ddUser.registerOnTouched(this.formControlTouched);
  }

  ngAfterViewInit (): void {
  }
  // #ControlValueAccessor
  writeValue(obj: any) {
    if (this.ddUser) {this.ddUser.writeValue(obj); }
  }
  public registerOnChange(fn: Function) {
    this.formControlChanged = fn || function() {};
  }

  public registerOnTouched(fn: Function) {
    this.formControlTouched = fn || function() {};
  }
  setDisabledState(isDisabled: boolean) {
    this.ddUser.setDisabledState(isDisabled);
  }
  // #end ControlValueAccessor
}
